export default {
	state: {
		addLoading: {
			loading: false,
		},
	},
	mutations: {
		requestAdding(state) {
			state.addLoading.loading = true;
		},
		successAdded(state) {
			state.addLoading.loading = false;
		},
	},
	actions: {
		async AddTheClientDetail({ commit }, params) {
			commit('requestAdding');
			await a.api('addkhd', params);
			commit('successAdded');
		},
	},
};
